import { render, staticRenderFns } from "./Strategic.vue?vue&type=template&id=0bcee0de&scoped=true"
import script from "./Strategic.vue?vue&type=script&lang=js"
export * from "./Strategic.vue?vue&type=script&lang=js"
import style0 from "./Strategic.vue?vue&type=style&index=0&id=0bcee0de&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcee0de",
  null
  
)

export default component.exports